module.exports = __webpack_public_path__ + "img/planet4.712d89ef.png";